import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  resetOfferAggregateEffect,
  setOffersFiltersAppliedEffect,
  setOffersFiltersEffect,
} from 'store/effects/offerAggregate';
import { getUserId } from 'store/selectors/user';
import {
  getOfferAggregateDataSelector,
  getOfferAggregateList,
  getOfferFiltersSelector,
} from 'store/selectors/offerAggregate';
import { getOfferAggregateByUserIdEffect } from 'store/effects/offerAggregate';

import { LocationService } from 'services';
import moment from 'moment';
import _, { isNumber } from 'lodash';
import { resetTransactionEffect } from 'store/effects';
import { getTransactionSelector } from 'store/selectors/transaction';

export const useFetchOffers = () => {
  const dispatch = useDispatch();
  const mountRef = useRef<boolean>();

  const { offersFilter } = useSelector(getOfferFiltersSelector);
  const { transaction } = useSelector(getTransactionSelector);
  const {
    offersFilter: { allFilters = {} },
  } = useSelector(getOfferFiltersSelector);

  const userId = useSelector(getUserId);
  const offerAggregate = useSelector(getOfferAggregateDataSelector);
  const { isPending } = useSelector(getOfferAggregateList);

  const locationSrv = new LocationService();
  locationSrv.setLocation(location);
  const query = locationSrv.getQuery();

  useEffect(() => {
    if (transaction.Id) {
      dispatch(resetTransactionEffect());
    }
  }, []);

  useEffect(() => {
    if (Object.keys(query).length) {
      const categorizedFilter = query.teamStats ? {} : { isMyOffers: true };
      const queryAllFilters = {
        ...(query.status && { status: query.status.split(',') }),
        ...(query.statuses && { statuses: query.statuses.split(',') }),
        ...(query.dueToday && { expiresFromDate: moment(), expiresToDate: moment() }),
        ...(query.offerIds && {
          offerIds: isNumber(query.offerIds) ? [query.offerIds] : query.offerIds.split(','),
        }),
      };

      if (!_.isEmpty(queryAllFilters) || !_.isEmpty(categorizedFilter)) {
        getOffers({ ...queryAllFilters, ...categorizedFilter }, () => {
          dispatch(setOffersFiltersAppliedEffect(true));
          dispatch(setOffersFiltersEffect({ allFilters: queryAllFilters, categorizedFilter }));
        });
      } else {
        getOffers();
      }
    } else {
      getOffers();
    }

    return () => {
      mountRef.current = false;
      dispatch(resetOfferAggregateEffect());
      dispatch(setOffersFiltersEffect({ searchString: '', allFilters: {}, categorizedFilter: {} }));
    };
  }, []);

  useEffect(() => {
    if (mountRef.current) {
      const { allFilters = {}, categorizedFilter = {}, searchString } = offersFilter;
      getOffers({ ...(searchString && { searchString }), ...allFilters, ...categorizedFilter });
    }
  }, [offersFilter]);

  const getOffers = (filters = {}, cb?) => {
    dispatch(
      getOfferAggregateByUserIdEffect(
        {
          id: userId,
          filters,
        },
        {},
        (error) => {
          if (!error) {
            cb?.();
            mountRef.current = true;
          }
        },
      ),
    );
  };

  return {
    offerAggregate,
    offersFilter,
    isPending,
    isFilterApplied: !!Object.keys(allFilters).length,
  };
};
